import React, { Component } from 'react';
import * as commonActions from '../../../../../../app/common/common.action';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../material.action';

import NumeroExternoModalPage from './numero-externo.page';
import WebapiCommon from '../../../../../../app/common/util/webapi.common';
import CommonFunctions from '../../../../../../app/common/util/functions.common';

import IntlMessage from '../../../../../../helpers/intlMessage';

class NumeroExernoModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topografias: [],
      inputNumeroExterno: props.detalhes.nrExameExterno
        ? props.detalhes.nrExameExterno
        : '',
      topografia: null,
      frasco: null,
      modalExcluir: false,
      justificativa: '',
      qtdBloco: props.detalhes.qtdBlocoExterno,
      qtdLamina: props.detalhes.qtdLaminaExterno,
      modoDeEdicao: false,
    };
  }

  componentDidMount() {
    WebapiCommon.getTopografias().then((response) => {
      var frascoExterno = this.getFrascoExterno(
        this.props.frascosGravados,
        this.props.detalhes.frascoExterno
      );
      this.setState({
        topografias: response,
        topografia: frascoExterno
          ? response.find((tp) => tp.value === frascoExterno.idTopografia)
          : null,
      });
    });
  }

  getFrascoExterno(frascosGravados, idFrascoExterno) {
    var frascoExterno = frascosGravados.find(
      (fr) =>
        fr.frascoId === idFrascoExterno &&
        fr.status.toLowerCase() !== 'cancelado'
    );
    this.setState({
      frascoExterno,
    });
    return frascoExterno;
  }

  onChange(name, value) {
    let valor = name !== 'topografia' ? value.currentTarget.value : value;

    if (name === 'qtdBloco' || name === 'qtdLamina') {
      if (/^[0-9]{0,6}$/.test(valor) && !!valor) {
        this.setState({
          [name]: valor,
        });
      }
    } else {
      this.setState({
        [name]: valor,
      });
    }
  }

  removerCodigoLabelTopografia(labelNovaTopografiaSelecionada) {
    let index = labelNovaTopografiaSelecionada.indexOf('-');
    let length = labelNovaTopografiaSelecionada.length;
    let labelNovaTopografiaSemCodigo = labelNovaTopografiaSelecionada
      .slice(index + 1, length)
      .trimStart();

    return labelNovaTopografiaSemCodigo;
  }

  gravar(pendente) {
    let { frascosNovos, detalhes } = this.props;

    this.props.commonActions.showFadeCarregando(true);

    if (frascosNovos.length > 0) {
      WebapiCommon.registrarFrasco(detalhes.laudo, frascosNovos).then(() => {
        WebapiCommon.getFrascos(detalhes.laudo).then((frascos) => {
          this.props.commonActions.adicionarFrasco(frascos);
          this.props.commonActions.adicionarNovoFrasco([]);
          this.cadastrarOuAtualizarTopografia(
            this.gravarNumero.bind(this),
            pendente
          );
        });
      });
    } else {
      this.cadastrarOuAtualizarTopografia(
        this.gravarNumero.bind(this),
        pendente
      );
    }
  }

  gravarNumero(frasco, pendente) {
    WebapiCommon.gravarNumeroExterno(
      this.props.detalhes.laudo,
      this.state.inputNumeroExterno,
      this.state.qtdBloco,
      this.state.qtdLamina,
      frasco ? frasco : 0
    )
      .then(() => {
        this.atualizarDetalhes(frasco);
        this.atualizarListagem();
        if (pendente) {
          this.props.closeModal();
          this.props.salvarPendente();
        } else {
          this.props.closeModal();
          this.props.finalizar();
        }
        this.props.commonActions.showFadeCarregando(false);
      })
      .catch(() => {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'erro',
          <IntlMessage id = "dashboards.examDetail.errorExamExternal"/>,
          1500,
          '600px'
        );
      });
  }

  atualizarDetalhes(frasco) {
    var detalhes = Object.assign(this.props.detalhes);

    detalhes.qtdBlocoExterno = this.state.qtdBloco;
    detalhes.qtdLaminaExterno = this.state.qtdLamina;
    detalhes.nrExameExterno = this.state.inputNumeroExterno;
    detalhes.frascoExterno = frasco.frascoId;

    this.props.commonActions.atualizarDetalhes(detalhes);
  }

  atualizarListagem() {
    let listagem = [...this.props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === this.props.detalhes.laudo
    );
    listagem[listagemIndex].nrExameExterno = this.state.inputNumeroExterno;
    listagem[listagemIndex].qtdBloco = this.state.qtdBloco;
    listagem[listagemIndex].qtdLamina = this.state.qtdLamina;
    this.props.commonActions.preencherListagem(listagem);
  }

  excluir() {
    this.props.commonActions.showFadeCarregando(true);
    if (this.state.frascoExterno) {
      let isUltimoFrasco =
        this.props.frascosGravados.filter((el) => el.status !== 'CANCELADO')
          .length === 1;
      WebapiCommon.cancelarFrasco(
        this.props.detalhes.laudo,
        this.state.frascoExterno.frascoId,
        <IntlMessage id = "dashboards.examDetail.bottleCanceled"/>
      ).then(() => {
        WebapiCommon.excluirExameExterno(
          this.props.detalhes.laudo,
          this.state.justificativa
        ).then(() => {
          if (isUltimoFrasco) {
            CommonFunctions.cancelarRecebimentoMaterial(
              this.props.detalhes,
              this.props.listagem,
              this.props.commonActions,
              this.state.justificativa
            ).then(() => {
              CommonFunctions.fecharExameEtapaRecebimento(this.props);
              this.props.commonActions.showFadeCarregando(false);
              this.props.commonActions.showAlerta(
                'sucesso',
                <IntlMessage id = "dashboards.examDetail.receiptMaterialCanceled"/>,
                2000,
                '500px'
              );
            });
          } else {
            WebapiCommon.getFrascos(this.props.detalhes.laudo).then(
              (frascos) => {
                this.props.commonActions.adicionarFrasco(frascos);
                this.limparDadosExameExterno();
                this.props.commonActions.showFadeCarregando(false);
                this.props.commonActions.showAlerta(
                  'sucesso',
                  <IntlMessage id = "dashboards.examDetail.externalExamDeleted"/>,
                  1500,
                  '600px'
                );
              }
            );
          }
        });
      });
    } else {
      WebapiCommon.excluirExameExterno(
        this.props.detalhes.laudo,
        this.state.justificativa
      ).then(() => {
        WebapiCommon.getFrascos(this.props.detalhes.laudo).then((frascos) => {
          this.props.commonActions.adicionarFrasco(frascos);
          this.limparDadosExameExterno();
          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.showAlerta(
            'sucesso',
            <IntlMessage id = "dashboards.examDetail.externalExamDeleted"/>,
            1500,
            '600px'
          );
        });
      });
    }
  }

  limparDadosExameExterno() {
    var detalhes = Object.assign(this.props.detalhes);
    detalhes.qtdBlocoExterno = 0;
    detalhes.qtdLaminaExterno = 0;
    detalhes.nrExameExterno = null;
    detalhes.frascoExterno = null;

    let listagem = [...this.props.listagem];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === this.props.detalhes.laudo
    );
    listagem[listagemIndex].nrExameExterno = null;
    listagem[listagemIndex].qtdBloco = 0;
    listagem[listagemIndex].qtdLamina = 0;

    this.props.commonActions.preencherListagem(listagem);
    this.props.commonActions.atualizarDetalhes(detalhes);
    this.props.closeModal();
  }

  toggleModalExcluir() {
    this.setState((state) => ({
      modalExcluir: !state.modalExcluir,
    }));
  }

  onChangeJustificativa(just) {
    this.setState({
      justificativa: just,
    });
  }

  alterarModoDeEdicao() {
    this.setState((state) => ({
      modoDeEdicao: !state.modoDeEdicao,
    }));
  }

  atualizarNumeroExterno() {
    let { frascoExterno } = this.state;
    this.props.commonActions.showFadeCarregando(true);
    this.cadastrarOuAtualizarTopografia(() => {
      WebapiCommon.gravarNumeroExterno(
        this.props.detalhes.laudo,
        this.state.inputNumeroExterno,
        this.state.qtdBloco,
        this.state.qtdLamina,
        frascoExterno ? frascoExterno.frascoId : 0
      )
        .then(() => {
          this.atualizarDetalhes(frascoExterno);
          this.atualizarListagem();
          this.alterarModoDeEdicao();
          this.props.commonActions.showFadeCarregando(false);
        })
        .catch(() => {
          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.showAlerta(
            'erro',
            <IntlMessage id = "dashboards.examDetail.errorUpdateInformation"/>,
            1500,
            '600px'
          );
        });
    }, true);
  }

  cadastrarOuAtualizarTopografia = (func, pendente) =>
    new Promise((resolve) => {
      let { frascoExterno, topografia } = this.state;
      let { detalhes } = this.props;

      if (
        frascoExterno &&
        topografia &&
        frascoExterno.idTopografia !== topografia.value
      ) {
        WebapiCommon.atualizarTopografia(
          detalhes.laudo,
          frascoExterno.frascoId,
          topografia.value,
          frascoExterno.topografia,
          this.removerCodigoLabelTopografia(topografia.label)
        ).then(() => {
          WebapiCommon.getFrascos(detalhes.laudo).then((frascos) => {
            this.props.commonActions.adicionarFrasco(frascos);
            resolve(func(frascoExterno.frascoId, pendente));
          });
        });
      } else if (!frascoExterno && topografia) {
        let frasco = {
          topografiaId: this.state.topografia.value,
          quantidade: 1,
        };

        WebapiCommon.gerarFrasco(detalhes.laudo, [frasco]).then((response) => {
          var newFrasco = response.data[0];
          WebapiCommon.registrarFrasco(detalhes.laudo, response.data).then(
            () => {
              WebapiCommon.getFrascos(detalhes.laudo).then((frascos) => {
                this.props.commonActions.adicionarFrasco(frascos);
                var frasco = frascos.find((fr) => {
                  return (
                    fr.dsFrasco === newFrasco.dsFrasco &&
                    fr.topografia === newFrasco.dsTopografia &&
                    fr.nrOrdem === newFrasco.nuOrdem
                  );
                });

                resolve(func(frasco.frascoId, pendente));
                this.getFrascoExterno(frascos, frasco.frascoId);
              });
            }
          );
        });
      } else {
        resolve(func(frascoExterno ? frascoExterno.frascoId : 0, pendente));
      }
    });

  render() {
    const numeroExterno = this.props.detalhes
      ? this.props.detalhes.nrExameExterno
      : undefined;
    const { modoDeEdicao } = this.state;
    return (
      <NumeroExternoModalPage
        isOpen={this.props.open}
        toggle={this.props.closeModal}
        gravarNumero={this.gravar.bind(this)}
        onChange={this.onChange.bind(this)}
        excluir={this.excluir.bind(this)}
        modalExcluir={this.state.modalExcluir}
        justificativa={this.state.justificativa}
        toggleModalExcluir={this.toggleModalExcluir.bind(this)}
        topografias={this.state.topografias}
        topografia={this.state.topografia}
        inputNumeroExterno={this.state.inputNumeroExterno}
        NumeroExterno={numeroExterno}
        frascoExterno={this.state.frascoExterno}
        onChangeJustificativa={this.onChangeJustificativa.bind(this)}
        statusRecebimento={
          this.props.detalhes.etapas.find((et) => et.etapa === 'MATERIAL')
            .status
        }
        qtdBloco={this.state.qtdBloco}
        qtdLamina={this.state.qtdLamina}
        modoDeEdicao={modoDeEdicao}
        alterarModoDeEdicao={this.alterarModoDeEdicao.bind(this)}
        atualizarNumeroExterno={this.atualizarNumeroExterno.bind(this)}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listagem: state.commonReducer.listagem,
    detalhes: state.commonReducer.detalhes,
    frascosGravados: state.commonReducer.frascosGravados,
    frascosNovos: state.commonReducer.frascosNovos,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NumeroExernoModalContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/numeroExterno/numero-externo.container.js